import * as Yup from 'yup';

export const daySchema = Yup.number()
	.typeError('Vui lòng nhập số')
	.nullable()
	.min(1, 'Ngày không hợp lệ')
	.max(31, 'Ngày không hợp lệ');

export const monthSchema = Yup.number()
	.typeError('Vui lòng nhập số')
	.nullable()
	.min(1, 'Tháng không hợp lệ')
	.max(12, 'Tháng không hợp lệ');

export const yearSchema = Yup.number().typeError('Vui lòng nhập số').nullable();

export const citizenIdSchema = Yup.string()
	.nullable()
	.test(
		'valid-idNumber',
		'Số CCCD hoặc Hộ chiếu không hợp lệ',
		(value: any) =>
			/^\d{9}$/.test(value) || /^\s{12}$/.test(value) || /^[A-Z]\s{7}$/.test(value) || !value
	);
